
import { mapState } from 'vuex'
export default {
  // 客户用例卡片
  name: 'CustomItem',
  props: {
    data: {
      type: Object,
      default: Object,
    },
    props: {
      type: Object,
      default: Object,
    },
  },
  computed: {
    ...mapState(['isMobile']),
    keys() {
      return {
        title: 'title',
        src: 'src',
        desc: 'desc',
        author: 'author',
        comment: 'comment', //
        ...this.props,
      }
    },
  },
}
